import { useCallback } from "react";
import { useBlocker, useNavigate, type BlockerFunction, type NavigateOptions, type To } from "react-router";

let skipNextTransition = false;

export function useSkipUnsavedChangesGuardNavigate() {
    const navigate = useNavigate();

    return useCallback(
        (to: To, options?: NavigateOptions) => {
            skipNextTransition = true;
            void navigate(to, options);
        },
        [navigate]
    );
}

export function useUnsavedChangesBlocker(isModified: boolean) {
    const shouldBlock = useCallback<BlockerFunction>(
        ({ currentLocation, nextLocation }) => {
            if (skipNextTransition) {
                skipNextTransition = false;

                return false;
            }

            return isModified && nextLocation.pathname !== currentLocation.pathname;
        },
        [isModified]
    );

    const blocker = useBlocker(shouldBlock);

    const confirmLeave = useCallback(() => blocker.proceed?.(), [blocker]);
    const cancelLeave = useCallback(() => blocker.reset?.(), [blocker]);

    return { isBlocked: blocker.state === "blocked", confirmLeave, cancelLeave } as const;
}
